import { MutationTuple, useMutation } from '@apollo/client';

import {
  BATCH_UPDATE_ASC_PROJECT_CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE,
  BatchUpdateAscProjectCapitalizableProjectClusteringOverrideMutation,
  BatchUpdateAscProjectCapitalizableProjectClusteringOverrideMutationVariables,
  GET_ASC_PROJECTS,
  GetAscProjectsQueryVariables,
  useCurrentCompanyId,
} from '@neo.tax/shared';

import { useAscContext } from '../context';

export const useBatchUpdateAscProjectCapitalizableProjectClusteringOverride = (): MutationTuple<
  BatchUpdateAscProjectCapitalizableProjectClusteringOverrideMutation,
  BatchUpdateAscProjectCapitalizableProjectClusteringOverrideMutationVariables
> => {
  const companyId = useCurrentCompanyId();
  const { fiscalYearId, periodName } = useAscContext();
  return useMutation<
    BatchUpdateAscProjectCapitalizableProjectClusteringOverrideMutation,
    BatchUpdateAscProjectCapitalizableProjectClusteringOverrideMutationVariables
  >(BATCH_UPDATE_ASC_PROJECT_CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: GET_ASC_PROJECTS,
        variables: { companyId, fiscalYearId, periodName } satisfies GetAscProjectsQueryVariables,
      },
    ],
  });
};
